/* ============================================================================
 * Movatic WMS — Frontend | MES » TerminalPage | CesarFilho 932048016
 * ----------------------------------------------------------------------------
 * MVP focado em rapidez: ler/teclar códigos e chamar consume/report/start.
 * Integra bem com leitores Zebra (hook de scanner, se existir).
 * ========================================================================== */

import React, { useEffect, useRef, useState } from "react";
import MES, { ProdOrder } from "@/api/mes";

let useKeyboardScanner: any;
try {
    // Se o projeto já tiver o hook, usamos. Senão, fallback simples.
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    useKeyboardScanner = require("@/hooks/useKeyboardScanner").default;
} catch {
    useKeyboardScanner = () => ({
        lastCode: null,
        bindProps: { onKeyDown: (_e: any) => { } },
    });
}

export default function TerminalPage() {
    const [order, setOrder] = useState<ProdOrder | null>(null);
    const [code, setCode] = useState("");
    const [status, setStatus] = useState<string>("");

    const inputRef = useRef<HTMLInputElement>(null);
    const scanner = useKeyboardScanner?.();

    useEffect(() => {
        if (scanner?.lastCode) setCode(scanner.lastCode);
    }, [scanner?.lastCode]);

    async function load(orderId: number) {
        try {
            const data = await MES.getOrder(orderId);
            setOrder(data);
            setStatus(data.status);
        } catch (e: any) {
            alert("OP não encontrada: " + e.message);
        }
    }

    async function doStart() {
        if (!order) return;
        await MES.start(order.id);
        const o = await MES.getOrder(order.id);
        setOrder(o); setStatus(o.status);
    }

    async function doConsume() {
        if (!order) return;
        const component = Number(prompt("ID do componente a consumir?", "0") || "0");
        if (!component) return;
        const qty = Number(prompt("Quantidade?", "1") || "1");
        const lot = prompt("Lote (opcional)", "") || "";
        await MES.consume(order.id, { component, qty, lot });
    }

    async function doReport() {
        if (!order) return;
        const qty = Number(prompt("Qtd produzida?", "1") || "1");
        const lot = prompt("Lote acabado (opcional)", "") || "";
        const sscc = prompt("SSCC (opcional)", "") || "";
        await MES.report(order.id, { qty, lot, sscc });
    }

    return (
        <div className="p-4 space-y-4">
            <h1 className="text-xl font-semibold">MES — Terminal de Apontamento</h1>

            <div className="flex gap-2 items-center">
                <input
                    ref={inputRef}
                    className="px-3 py-2 rounded bg-gray-900 border border-gray-700 w-80"
                    placeholder="Digite/escaneie: OP-0001 ou ID"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            const id = Number(code) || undefined;
                            if (id) load(id);
                        }
                    }}
                    {...(scanner?.bindProps || {})}
                />
                <button className="px-3 py-2 rounded bg-gray-800" onClick={() => { const id = Number(code) || 0; if (id) load(id); }}>Carregar OP</button>
            </div>

            {order && (
                <div className="space-y-3">
                    <div className="rounded border border-gray-800 p-3">
                        <div><b>OP:</b> {order.ref_code} &nbsp; <b>ID:</b> {order.id}</div>
                        <div><b>Produto:</b> {order.product_code ?? order.product} &nbsp; <b>Qtd:</b> {order.qty} {order.uom}</div>
                        <div><b>Estado:</b> <span className="px-2 py-0.5 rounded bg-gray-800">{status}</span></div>
                    </div>

                    <div className="flex gap-2">
                        <button className="px-3 py-2 rounded bg-gray-800" onClick={doStart}>Iniciar</button>
                        <button className="px-3 py-2 rounded bg-gray-800" onClick={doConsume}>Consumir</button>
                        <button className="px-3 py-2 rounded bg-gray-800" onClick={doReport}>Reportar</button>
                    </div>
                </div>
            )}
        </div>
    );
}
